module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "ssg-poi-inactive.ab56cd5e.svg";